export const ACCORDION_TYPE_ENUM = ['regular', 'playerList', 'certificateCard'];
